// import request from './huddle-request';

const methods = ({ request }) => ({
  // Gives the lookup table to associate stats to formula values
  // IE: formulaOptions.QB[0].id === 3
  // formula.values.3.points === 20
  getOptions: async () => request('User/FormulaOptions'),

  // Returns array of ALL user's formula AND any public formula available
  // Public formula have an id of 0, custom are everything else
  getAll: async () => request('User/GetFormulas'),

  // Returns just the formula object requested
  getById: async ({ formulaId }) => request(`User/Formula/${formulaId}`),

  // Adds a new custom formula
  createNew: async ({ formula }) =>
    request('User/Formula', { method: 'POST', body: formula }),

  // Edit an existing custom formula
  update: async ({ id, formula }) =>
    request(`User/Formula/${id}`, { method: 'PUT', body: formula }),

  // Delete existing formula
  deleteFormula: async ({ id }) =>
    request(`User/Formula/${id}`, { method: 'DELETE' }),

  // Update default formula to new id
  setDefault: async id =>
    request('User/Formula/Default', { method: 'PUT', body: { formula_id: id } }),
});

export default methods;



// WEBPACK FOOTER //
// ./src/lib/api/formula.js